import { gql } from 'apollo-boost';

export default gql`
  mutation increaseOrderExpectedTime($input: IncreaseOrderExpectedTimeInput!) {
    increaseOrderExpectedTime(input: $input)
  }
`;
